import React, { useState } from 'react';
import Panel from 'Components/Panel/Panel';
import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import OperationsProduct from './OperationsProduct/OperationsProduct';
import Products from './Products/Products';
import ProductFilters from './filters/ProductFilters';

const ProductsOperations = () => {

    const [productIdSelected, setProductIdSelected] = useState([])
    const [productOperationIdSelected, setProductOperationIdSelected] = useState([])
    const [productFilters, setProductFilters] = useState(null)
    const [supplierIdSelected, setSupplierIdSelected] = useState([])


    const mainStyle = {
        display: 'flex',
        flexDirection: 'row',
        minHeight: '100%',
        maxHeight: '100%',
        width: '100%'
    };

    const leftStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
    };

    return (
        <LayoutDefault>
            <Panel style={mainStyle}>
                <Panel style={leftStyle} className={'main-modal two left'}>
                    <ProductFilters
                        onUpdateFilters={setProductFilters}
                        onUpdateSupplierIdSelected={val => { setSupplierIdSelected(val) }}
                        supplierIdSelected={supplierIdSelected}
                    />
                    <Products
                        onUpdateProductIdSelected={setProductIdSelected}
                        productIdSelected={productIdSelected}
                        productFilters={productFilters}
                    />
                </Panel>
                
                <OperationsProduct
                    onUpdateProductOperationIdSelected={setProductOperationIdSelected}
                    productOperationIdSelected={productOperationIdSelected}
                    productIdSelected={productIdSelected}
                />
            </Panel>
        </LayoutDefault>
    );
};

export default ProductsOperations;
